<script type="text/jsx">
import { parseColorApontamento } from 'src/utils'

function buildApontamentos (h, timemeasurements) {
  const apontamentos = timemeasurements || {}

  const visualApontamentos = []

  const rendered = (item, key, forceClass = null) => {
    return (
      <div class="apontamentos-class" title={item.hover}>
        <span class={'apontamento-span-hh-mm ' + (forceClass || `apontamento-color-${parseColorApontamento(key)}`)}>
          {item.value}
        </span>
        <label>{item.text}</label>
      </div>
    )
  }

  for (const key in apontamentos) {
    if (['to_be_recalculated', 'total_hrs', 'obs'].includes(key) || !apontamentos[key].value) {
      continue
    }
    visualApontamentos.push(rendered(apontamentos[key], key))
  }

  return visualApontamentos
}

export default {
  functional: true,
  props: {
    line: { type: Object, required: true },
    toBeRecalculated: { type: Boolean },
    allowEdit: { type: Object },
    rowNumber: { type: Number },
    recalculating: { type: Boolean },
    recalculatingWHB: { type: Boolean }
  },
  render (h, context) {
    const { props } = context
    const { line } = props

    const timeMeasurements = line.apontamentos || {}

    return (
      <div class="apontamentos-container">
        <div class="visual-apontamentos">
          { buildApontamentos(h, timeMeasurements) }
        </div>
      </div>
    )
  }
}
</script>

<style scoped="">
  @keyframes apontsping {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }
  .apont-spin-span {
    animation-name: apontsping;
    animation-duration: 5000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  .apontamentos-container {
    overflow: hidden;
    height: 100%;
    width: 100%;
    display: grid;
    margin-top: 5%;
    padding: 3px 10px 3px 10px;
    align-items: center;
  }

  .btn-apontamento {
    width: 50px;
    font-size: 11px;
    padding: 0px;
    align-items: center;
  }
  .visual-apontamentos {
    height: 100%;
  }
  .whbo-container {
    overflow-y: scroll;
    height: 90px;
  }

  .apontamento-span-hh-mm {
    font-size: 11px !important;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
  }

  .apontamentos-class span, .apontamentos-class label {
    animation: slide-up 0.2s ease-out;
  }

  .apontamentos-class label{
    font-size: 13px !important;
    text-align: left;
  }
  .apontamentos-class {
    display: grid;
    grid-template-columns: 0.3fr 1fr;
    grid-column-gap: 7px;
    height: 20px !important;
    align-items: center;
    margin-bottom: 2px;
  }
  .apontamentos-class.loading > span:first-child {
    width: 100%;
    height: 16px;
    background-color: lightgray;
  }
  .apontamentos-class.loading > span:last-child {
    width: 60%;
    height: 16px;
    background-color: lightgray;
  }
</style>

<style lang="scss">
  $colors: success, danger, info, warning, danger, default;

  @each $color in $colors {
    .bh-apontamento-#{$color} {
      color: var(--color-#{$color}-contrast);
      background-color: var(--color-#{$color});
      border-top: 2px solid var(--color-#{$color});
      border-bottom: 3px solid var(--color-#{$color}-border);
      user-select: none;
      transition: 0.3s all linear;

      &:hover, &:active  {
        border-top: 2px solid var(--color-#{$color}-hover) !important;
        background-color: var(--color-#{$color}-hover) !important;
      }
      &:active {
        top: 3px;
        border-bottom: none;
      }
    }

    .apontamento-color-#{$color} {
      border: 2px solid var(--color-#{$color});
    }

    .bh-apontamento-disabled-#{$color} {
      color: var(--color-#{$color}-contrast);
      background-color: var(--color-#{$color});
      border-top: 2px solid var(--color-#{$color});
      user-select: none;
      transition: 0.3s all linear;
    }
  }
</style>
